import { IoChevronBack } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics,Gtag } from '../compornents/Analytics';

export const Coupon = () => {
  const location = useLocation();
  // console.log(location);
  let data = undefined;
  if(location.state !== null && location.state.data !== undefined){
    data = location.state.data;
  }
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [coupon_no, setCouponNo] = useState("");
  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  // クーポン作成
  async function createCoupon() {
    openLoadingModal();
    // console.log('update');
    // 見積もり取得
    const request_data = {
      'coupon_no': coupon_no
     };
    const response_data = await Post('post', '/customer/create_coupon.php', request_data);
    // console.log(response_data);
    if (response_data.result === 1) {
      Gtag('create_coupon_success');
      setCoupons(response_data.coupons);
    } else {
      // エラー
      toast.error(response_data.error_message);
      Gtag('create_coupon_failed');
    }
    closeLoadingModal();
  };
  // クーポン選択
  async function selectCoupon(coupon) {
    if(location.state !== null && location.state.data !== undefined){
        data.coupon = coupon;
        // クーポンは data(メモリ)だけだと画面遷移で消えるため sessionStorage を真実源にする
        try { sessionStorage.setItem('lp_selected_coupon', JSON.stringify(coupon)); } catch (e) {}
        navigate("/confirm", { state: { data:data, from:'coupon' }});
    }else{
      navigate("/home");
    }
  }
  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // 顧客情報取得
    async function getCoupons() {
      const request_data = {}
      // post
      const response_data = await Post('post', '/customer/coupons.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {
        const coupons = response_data.coupons;
        setCoupons(coupons);
      } else {
        // エラー

      }
    }
    getCoupons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 戻る
  const back = () => {
    if(location.state !== null && location.state.data !== undefined){
      navigate("/confirm", { state: { data:data, from:'coupon' }});
    }else{
      navigate("/account");
    }
  };

  // 注文フロー(confirm)から来た時だけ「選ぶ」で適用できる。タブからの単独表示は閲覧のみ。
  const orderMode = data !== undefined;
  const hasUnused = coupons.some((c) => String(c.riyou) === '0');
  return (
    <div className="App">
      <div className="Address">
        <Analytics title="クーポン" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            クーポン
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="m-4">
          {/* マイクーポン（主役） */}
          <div className="mc-head">
            <h4 className="mc-title">マイクーポン</h4>
            <span className="mc-note">（Uber配達手数料には適用されません）</span>
          </div>
          {orderMode && hasUnused && (
            <p className="mc-hint">使うクーポンをタップしてください。</p>
          )}
          {!orderMode && hasUnused && (
            <p className="mc-hint">ご注文のお会計画面で選んでご利用いただけます。</p>
          )}
          {coupons.length > 0 ? (
            <div className="mycoupon-list">
              {coupons.map((coupon, i) => {
                const used = String(coupon.riyou) !== '0';
                const selectable = orderMode && !used;
                return (
                  <div
                    key={coupon.id}
                    className={`mc-card${used ? ' is-used' : ''}${selectable ? ' is-selectable' : ''}`}
                    style={{ animationDelay: `${Math.min(i, 8) * 60}ms` }}
                    onClick={selectable ? () => selectCoupon(coupon) : undefined}
                  >
                    <div className="mc-thumb">
                      {coupon.img
                        ? <img src={coupon.img} alt="" />
                        : <span className="mc-thumb-ph" role="img" aria-label="クーポン">🎟️</span>}
                    </div>
                    <div className="mc-body">
                      <div className="mc-name">{coupon.name}</div>
                      <div className="mc-amount"><span className="mc-yen">{Number(coupon.kingaku || 0).toLocaleString()}</span>円引き</div>
                      <div className="mc-exp">有効期限 {coupon.kigen_day} まで</div>
                    </div>
                    <div className="mc-action">
                      {used
                        ? <span className="mc-badge used">使用済み</span>
                        : selectable
                          ? <span className="mc-badge use">選ぶ ›</span>
                          : <span className="mc-badge ok">未使用</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="mc-empty">
              <div className="mc-empty-emoji" role="img" aria-label="クーポン">🎟️</div>
              クーポンはまだありません
            </div>
          )}

          {/* クーポンコード追加（控えめ・下部） */}
          <div className="mc-add">
            <div className="mc-add-title">クーポンコードをお持ちの方</div>
            <div className="mc-add-row">
              <input type="text" className="form-control" placeholder="クーポンコード" value={coupon_no} onChange={e => setCouponNo(e.target.value)} />
              <button className="btn btn-oval btn-yellow" onClick={() => createCoupon()}>追加</button>
            </div>
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
        <Tabbar menu="coupon" />
      </div>
    </div>
  );



}
